// extracted by mini-css-extract-plugin
export default {"loader":"Input_loader__FVBO7","rotation":"Input_rotation__M0Ps4"};